import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-subscriber',
  templateUrl: './add-subscriber.component.html',
  styleUrls: ['./add-subscriber.component.scss']
})
export class AddSubscriberComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
